import { katTranslator } from '../../shared/i18n';

const strings = {
  'kat-modal-close': {
    'en-US': 'close',
  },
  'kat-modal-dialog-label': {
    'en-US': 'Feedback form',
  },
};

export default katTranslator(strings);
